//前面的是上传的名字，后面是存到数据库里的名字
let positionMap = {
    "首页品牌专区": "品牌专区",
    "首页开屏贴片": "开屏广告",
    "首页顶部贴片": "首页顶部",
    "首页小横幅": "首页腰线",
    "首页猜你喜欢轮播置顶": "首页猜你喜欢",
    "首页热门楼盘位置": "评测推荐",
    "正在公示banner": "正在公示顶部",
    "正在登记banner": "正在登记顶部",
    "预计开盘banner": "预计开盘顶部",
    "预计开盘楼盘置顶": "预计开盘置顶",
    "搜索框推荐": "搜索框",
    "搜索楼盘推送": "搜索置顶",
    "公寓专区顶部贴片": "公寓顶部",
    "公寓专区楼盘置顶": "公寓置顶",
    "大平层专区顶部贴片": "大平层顶部",
    "买房问答顶部贴片": "买房问答顶部",
    "土拍地图顶部贴片": "土拍顶部",
    "摇号查询顶部贴片": "摇号查询顶部",
    "竞品楼盘底部展示": "上竞品的楼盘页",
    "封面图":"封面图",
    '1v1弹窗':'1v1服务弹窗',

    '日照评测楼盘推荐（3/4号位）': '日照评测楼盘推荐',
    '户型评测楼盘推荐（3/4号位）': '户型评测楼盘推荐',
    '噪声评测楼盘推荐（3/4号位）': '噪声评测楼盘推荐',

    '首页点击榜楼盘推荐（3/4号位）': '首页点击榜楼盘推荐',
    '首页热搜榜楼盘推荐（3/4号位）': '首页热搜榜楼盘推荐',
    '首页中签榜楼盘推荐（3/4号位）': '首页中签榜楼盘推荐',
    '首页倒挂榜楼盘推荐（3/4号位）': '首页倒挂榜楼盘推荐',
    '首页产业榜楼盘推荐（3/4号位）': '首页产业榜楼盘推荐',
    '首页配套榜楼盘推荐（3/4号位）': '首页配套榜楼盘推荐',
    '首页日照噪声榜楼盘推荐（3/4号位）': '首页日照噪声榜楼盘推荐',
    '首页规划榜楼盘推荐（3/4号位）': '首页规划榜楼盘推荐',

    '特惠楼盘置顶': '特惠楼盘置顶',
    '搜索页楼盘筛选置顶': '搜索页楼盘筛选置顶',

    '日照评测顶部贴片': '日照评测顶部贴片',
    '噪声评测顶部贴片': '噪声评测顶部贴片',
    '户型评测顶部贴片': '户型评测顶部贴片',

    '二手房首页顶部贴片': '二手房首页顶部贴片',
    '二手房首页小横幅': '二手房首页小横幅',
    '成交查询顶部贴片': '成交查询顶部贴片',
    '降价房源顶部贴片': '降价房源顶部贴片',

    '共有产权顶部贴片': '共有产权顶部贴片',
    '在售楼盘轮播置顶': '在售楼盘轮播置顶',
    '在售楼盘顶部贴片': '在售楼盘顶部贴片',
    '学区热盘顶部贴片': '学区热盘顶部贴片',
    '次新热盘顶部贴片': '次新热盘顶部贴片',
    '地铁热盘顶部贴片': '地铁热盘顶部贴片',
    '刚需热盘顶部贴片': '刚需热盘顶部贴片',
    '改善热盘顶部贴片': '改善热盘顶部贴片',
    '在售楼盘一直置顶': '在售楼盘一直置顶',
    '找房顶部':'找房顶部',
    '热门楼盘顶部贴片':'热门楼盘顶部贴片',
    '新房首页小横幅': '新房首页小横幅',
    '市场行情':'市场行情',
    '热门楼盘列表轮播置顶':'热门楼盘列表轮播置顶',
    '楼市行情新房':'楼市行情新房',
    '楼市行情二手房':'楼市行情二手房', 
}

let rmap = {};

for (let key in positionMap) {
    rmap[positionMap[key]] = key;
}

export default {
    show2value: positionMap,
    value2show: rmap,

    
};


// WEBPACK FOOTER //
// ./src/config/adPosition.js